import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import ResetPasswordForm from "components/modules/auth/ResetPasswordForm";
import AuthSimpleLayout from "layouts/AuthSimpleLayout";
import { useState, useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

const postResetPassword = async (data: {
  email: string;
  token: string;
  senha: string;
  confirmaSenha: string;
}) => {
  return await axios.post("/api/account/reset-password", data);
};

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [validationError, setValidationError] = useState<string | null>(null);

  const email = searchParams.get("email") || "";
  const token = searchParams.get("token") || "";

  const { isPending, data, mutate, error } = useMutation<any, any, any>({
    mutationFn: postResetPassword,
  });

  // Parse error message whenever error changes
  useEffect(() => {
    if (error?.response?.data) {
      console.log("Password reset error:", error.response.data);
      parseErrorMessage(error.response.data);
    }
  }, [error]);

  const parseErrorMessage = (errorData: any) => {
    // Direct check for the format shown in the example
    if (errorData && typeof errorData === "object" && "" in errorData) {
      const emptyKeyErrors = errorData[""];
      if (Array.isArray(emptyKeyErrors) && emptyKeyErrors.length > 0) {
        setValidationError(emptyKeyErrors.join(". "));
        return;
      }
    }

    // Handle standard ASP.NET Core validation errors
    if (errorData?.errors) {
      const errorMessages: string[] = [];

      // Look for empty string key in errors
      if (errorData.errors[""] && Array.isArray(errorData.errors[""])) {
        errorMessages.push(...errorData.errors[""]);
      }

      // Process all other error properties
      Object.entries(errorData.errors).forEach(([key, value]) => {
        if (key !== "" && Array.isArray(value)) {
          errorMessages.push(...(value as string[]));
        }
      });

      if (errorMessages.length > 0) {
        setValidationError(errorMessages.join(". "));
        return;
      }
    }

    // Handle other error formats
    if (errorData?.message) {
      setValidationError(errorData.message);
    } else if (typeof errorData === "string") {
      setValidationError(errorData);
    } else {
      setValidationError("Erro ao redefinir senha. Tente novamente.");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const password = e.currentTarget.password.value;
    const confirmPassword = e.currentTarget.confirmPassword.value;

    if (password !== confirmPassword) {
      setValidationError("As senhas não coincidem");
      return;
    }

    setValidationError(null);
    await mutate({
      email,
      token,
      senha: password,
      confirmaSenha: confirmPassword,
    });
  };

  if (!email || !token) {
    return (
      <Navigate to="/pages/authentication/simple/forgot-password" replace />
    );
  }

  if (data?.data) {
    return <Navigate to="/pages/authentication/simple/sign-in" replace />;
  }

  return (
    <AuthSimpleLayout>
      <ResetPasswordForm
        onSubmit={handleSubmit}
        validationError={validationError}
        loading={isPending}
      />
    </AuthSimpleLayout>
  );
};

export default ResetPassword;
